import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import LiveView from './liveView';
import styles from './deviceLogs.module.css';

type LogMode = 'live' | null;

interface DeviceLogsProps {
    deviceName: string;
}

const DeviceLogs: React.FC<DeviceLogsProps> = ({ deviceName }) => {
    const [mode, setMode] = useState<LogMode>(null);

    // Base Log mode 
    if (mode === null) {
        return (
            <Box className={styles.container}>
                <Typography variant="h6">Device Logs</Typography>
                <Box className={styles.modeSelection}>
                    <Button variant="contained" onClick={() => setMode('live')}>
                        Live View
                    </Button>
                </Box>
            </Box>
        );
    }

    // Live Log Mode
    return (
        <Box className={styles.container}>
            <LiveView deviceName={deviceName} onBack={() => setMode(null)} />
        </Box>
    );

};

export default DeviceLogs;
